import { CURRENCY_NAMES } from "../constants/currencies";
import UnitAmount from "./UnitAmount";

type Currency = keyof typeof CURRENCY_NAMES;

interface CurrencyAmountProps {
  color?: string;
  fontSize?: string | number;
  fontWeight?: string | number;
  style?: React.CSSProperties;
  currency?: Currency;
  amount?: number | string;
  [key: string]: any; // for ...props spread
}

export function CurrencyAmount({
  currency = 'IRT',
  ...props
}: CurrencyAmountProps) {
  return <UnitAmount unit={CURRENCY_NAMES[currency] || currency || ''} {...props} />;
}

export default CurrencyAmount;
